import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CheckoutService } from '../../utils/services/checkout.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { DataCFDI } from '../../../../../../views/clientes/model/DataAddress';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-uso-cfdi',
  templateUrl: './uso-cfdi.component.html',
  styleUrls: ['./uso-cfdi.component.scss']
})
export class UsoCfdiComponent implements OnInit {
  public CFDI$: Observable<DataCFDI>;
  public formulario: FormGroup;
  public cfdiUser: string;
  private unsubscribe$ = new Subject<void>();
  @Output() execCfdi: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private checkoutService: CheckoutService,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.CFDI$ = this.checkoutService.getUsoCdfi();
    this.buildForm();
    this.updateForm();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private buildForm = () => {
    this.formulario = this.formBuilder.group({ CFDI: ['', [Validators.required]] });
    //Optiene el uso de cfdi del cliente a como esta en el catalogo de clientes en zafiro.
    this.CFDI$.subscribe(res => {
      console.log('USO CFDI', res.ClienteCFDI)
      this.cfdiUser = res.ClienteCFDI;
      this.formulario.get('CFDI').setValue(this.cfdiUser);
    });
    //Emite el valor del CFDI SELECCIONADO
    this.formulario.get('CFDI').valueChanges.pipe(
      takeUntil(this.unsubscribe$),
    ).subscribe(res => {
      if (res) {
        this.execCfdi.emit(res);
      }
    });
  }

  public isInValidateForm = (input: string): boolean => {
    return this.getInput(input).invalid && this.getInput(input).touched;
  }
  public isValidateForm = (input: string, length: number): boolean => {
    return this.getInput(input).valid && this.getInput(input).touched &&
      this.getInput(input).value.length > length;
  }
  public getInput = (input: string) => {
    return this.formulario.get(input);
  }
  private getCFDI = (): string => {
    return localStorage.getItem('cliente-CFDI');
  }
  private updateForm() {
    this.checkoutService.getformularioCheckout$().pipe(takeUntil(this.unsubscribe$)).subscribe((activo: Boolean) => {
      if (activo) {
        this.formulario.disable();
      } else {
        this.formulario.enable();
      }
    });
  }

}
